import { render, staticRenderFns } from "./task-assignee-picker.vue?vue&type=template&id=4eb929ce&scoped=true&"
import script from "./task-assignee-picker.vue?vue&type=script&lang=js&"
export * from "./task-assignee-picker.vue?vue&type=script&lang=js&"
import style0 from "./task-assignee-picker.vue?vue&type=style&index=0&id=4eb929ce&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb929ce",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VChip,VMenu,VProgressLinear})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4eb929ce')) {
      api.createRecord('4eb929ce', component.options)
    } else {
      api.reload('4eb929ce', component.options)
    }
    module.hot.accept("./task-assignee-picker.vue?vue&type=template&id=4eb929ce&scoped=true&", function () {
      api.rerender('4eb929ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tarefas/components/task-assignee-picker/task-assignee-picker.vue"
export default component.exports